import { render, staticRenderFns } from "./PubContentEditable.vue?vue&type=template&id=4fbc792e"
import script from "./PubContentEditable.vue?vue&type=script&lang=js"
export * from "./PubContentEditable.vue?vue&type=script&lang=js"
import style0 from "./PubContentEditable.vue?vue&type=style&index=0&id=4fbc792e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports